import { Button, COLOR_INFO_60, IconMail, LazyImage, Text } from '@consumidor-positivo/aurora';
import { maskCellphone } from '@libs/utils/masks/cellphone';
import UpdateContactDataModal from './UpdateContactDataModal';
import WhatsappIcon from '@dues/assets/images/whatsapp-icon.svg';
import UpdatedWithSuccessWarning from './UpdatedWithSuccessWarning';
import DashedDivider from '@libs/atlas/components/DashedDivider';
import useUpdateContactData from './hooks';

import './styles.scss';
interface UpdateContactDataProps {
  partnerLogo: string;
}
const UpdateContactData = ({ partnerLogo }: UpdateContactDataProps) => {
  const { isModalOpen, setIsModalOpen, showWarning, setShowWarning, flowType, currentStep, setCurrentStep, handleUpdateDateClick, data, user } =
    useUpdateContactData();

  return (
    <div className="update-contact-data" id="update-contact-data">
      <div className="update-contact-data__icons-container">
        <div className="update-contact-data__icon update-contact-data__icon--first">
          <LazyImage width={32} height={32} src={partnerLogo} />
        </div>
        <div className="update-contact-data__icon update-contact-data__icon--center">
          <IconMail rawColor={COLOR_INFO_60} />
        </div>

        <div className="update-contact-data__icon update-contact-data__icon--last">
          <LazyImage src={WhatsappIcon} width={32} height={32} />
        </div>
      </div>

      <div className="update-contact-data__content">
        <div className="update-contact-data__header">
          <Text variant="heading-micro" weight="bold">
            Seu número e email mudaram?
          </Text>
          <Text color="secondary">Atualize seus dados e te avisaremos por E-mail e Whatsapp sobre suas parcelas e vencimentos.</Text>
        </div>

        <DashedDivider />

        <div className="update-contact-data__info update-contact-data__info--padding">
          <div>
            <Text color="secondary">Número de celular atual:</Text>
            <Text color="secondary" weight="bold">
              {maskCellphone(user.phone || '')}
            </Text>
          </div>

          <Button type="ghost" onClick={() => handleUpdateDateClick('cellphone')}>
            Editar
          </Button>
        </div>
        <div className="update-contact-data__line" />
        <div className="update-contact-data__info">
          <div>
            <Text color="secondary">E-mail atual:</Text>
            <Text color="secondary" weight="bold" className="update-contact-data__email">
              {user.email}
            </Text>
          </div>
          <Button type="ghost" onClick={() => handleUpdateDateClick('email')}>
            Editar
          </Button>
        </div>

        <UpdateContactDataModal
          currFlow={data[flowType as keyof typeof data]?.type}
          isOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setShowWarning={setShowWarning}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      </div>

      <UpdatedWithSuccessWarning warningText={data[flowType as keyof typeof data]?.warningText} showWarning={showWarning} />
    </div>
  );
};

export default UpdateContactData;
